import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthClient } from '../auth/auth.client';
import { Observable, Observer } from 'rxjs';

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate {

  constructor(private _authClient: AuthClient) { }

  canActivate() {
    return this._authClient.isAuthenticatedAsync().map(e => {
      if (e) {
        return true;
      }
    }).catch(() => {
      return Observable.of(false);
    });
  }
}
